/**
 * /auth/impersonate — Admin preview entry point.
 *
 * Opened by the admin panel when an operator/owner clicks "Preview as brand".
 * Reads ?pid=<partner_id>&t=<token> from the URL, exchanges the one-time
 * token for a 1-hour partner JWT, stores it, then redirects to the dashboard.
 *
 * Shows an "Admin preview" banner on all protected pages (via auth context).
 */
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import partnerApi from '../api';

export default function Impersonate() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const pid = searchParams.get('pid');
    const t = searchParams.get('t');

    if (!pid || !t) {
      setError('Invalid preview link — missing parameters.');
      return;
    }

    partnerApi.post('/auth/exchange-imp-token', { partner_id: pid, token: t })
      .then(({ data }) => {
        localStorage.setItem('partner_mahi_token', data.token);
        localStorage.setItem('partner_mahi_is_impersonation', 'true');
        localStorage.setItem('partner_mahi_brand_name', data.brand_name || '');
        // Force a full reload so auth context re-reads the new token
        window.location.href = '/dashboard';
      })
      .catch((err) => {
        const detail = err?.response?.data?.detail || 'Preview link is invalid or has expired.';
        setError(detail);
      });
  }, []); // eslint-disable-line

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-surface-page px-4 text-center">
        <span className="mb-4 text-3xl">⚠️</span>
        <h1 className="text-base font-semibold text-ink">Preview link expired</h1>
        <p className="mt-1 text-sm text-ink-secondary">{error}</p>
        <p className="mt-3 text-xs text-ink-muted">Generate a new link from the admin panel.</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-surface-page px-4 text-center">
      <div className="mb-4 h-8 w-8 animate-spin rounded-full border-2 border-raspberry-200 border-t-raspberry-600" />
      <p className="text-sm text-ink-secondary">Opening partner preview…</p>
    </div>
  );
}
